var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 016-6h118a6 6 0 016 6v28a6 6 0 01-6 6H6a6 6 0 01-6-6V6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.435 7.548c-.291.308-.462.785-.462 1.404V31.05c0 .619.17 1.096.462 1.404l.074.072 12.379-12.38v-.291L9.508 7.475l-.073.073z",
    fill: "#00D7FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "google-play_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 12,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.012 24.274l-4.125-4.128v-.291l4.127-4.128 4.982 2.83c1.396.795 1.396 2.093 0 2.886l-4.89 2.777-.094.055z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-play_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.012 24.274l-4.125-4.128v-.291l4.127-4.128 4.982 2.83c1.396.795 1.396 2.093 0 2.886l-4.89 2.777-.094.055z",
    fill: "url(#google-play_svg__paint0_linear_957_10620)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "google-play_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 20,
    width: 18,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.108 24.22L21.889 20 9.437 32.453c.46.487 1.22.547 2.076.061l14.596-8.294z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-play_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.108 24.22L21.889 20 9.437 32.453c.46.487 1.22.547 2.076.061l14.596-8.294z",
    fill: "url(#google-play_svg__paint1_linear_957_10620)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "google-play_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 18,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.108 15.78L11.512 7.486c-.856-.486-1.615-.426-2.076.061L21.889 20l4.22-4.22z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google-play_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.108 15.78L11.512 7.486c-.856-.486-1.615-.426-2.076.061L21.889 20l4.22-4.22z",
    fill: "url(#google-play_svg__paint2_linear_957_10620)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.894 30.953h1.866V18.452h-1.866v12.501zm16.807-7.998l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.329 7.575-1.898 4.214h1.947l5.13-11.789h-2.075zm-10.582 6.578c-.612 0-1.464-.305-1.464-1.061 0-.965 1.062-1.335 1.978-1.335.821 0 1.206.177 1.705.418a2.262 2.262 0 01-2.219 1.978zm.225-6.851c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.691 1.013-.917 1.705-.917.965 0 1.946.579 1.962 1.609v.128c-.338-.193-1.061-.482-1.946-.482-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.751 3.104 2.751 1.255 0 1.946-.563 2.381-1.223h.064v.965h1.801V26.14c0-2.22-1.656-3.458-3.795-3.458zm-11.532 1.795h-2.654v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .969-.792 2.143-2.187 2.143zm-.048-6.025h-4.471v12.501h1.865v-4.736h2.606c2.068 0 4.101-1.498 4.101-3.883s-2.033-3.882-4.101-3.882zM74.383 29.535c-1.289 0-2.368-1.079-2.368-2.561 0-1.498 1.079-2.594 2.368-2.594 1.273 0 2.271 1.096 2.271 2.594 0 1.482-.998 2.561-2.271 2.561zm2.142-5.88h-.064c-.419-.499-1.224-.95-2.239-.95-2.127 0-4.076 1.868-4.076 4.269 0 2.384 1.949 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.869 2.498-2.271 2.498-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.191 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693zm3.062 7.298h1.869V18.451h-1.869v12.502zm4.623-4.124c-.048-1.643 1.273-2.481 2.223-2.481.742 0 1.37.37 1.579.902l-3.802 1.579zm5.8-1.418c-.354-.95-1.434-2.706-3.641-2.706-2.191 0-4.011 1.723-4.011 4.253 0 2.384 1.804 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.483.709-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.288l5.687-2.352-.193-.484zM44.702 24.01v1.804h4.317c-.129 1.015-.467 1.756-.982 2.272-.629.628-1.612 1.32-3.335 1.32-2.658 0-4.737-2.142-4.737-4.8 0-2.659 2.079-4.801 4.737-4.801 1.434 0 2.481.564 3.254 1.289l1.273-1.273C48.149 18.79 46.716 18 44.702 18 41.061 18 38 20.965 38 24.606s3.061 6.605 6.702 6.605c1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.419-.032-.805-.097-1.127h-6.073zm11.079 5.525c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.288 0 2.4 1.047 2.4 2.578 0 1.514-1.112 2.577-2.4 2.577zm0-6.83c-2.353 0-4.27 1.788-4.27 4.253 0 2.448 1.917 4.253 4.27 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253zm9.313 6.83c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.577-2.4 2.577zm0-6.83c-2.352 0-4.269 1.788-4.269 4.253 0 2.448 1.917 4.253 4.269 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.471 10.814v2.342a2.08 2.08 0 01-.378.396c-.173.143-.411.27-.716.378-.302.105-.692.158-1.169.158-.39 0-.748-.067-1.077-.202a2.429 2.429 0 01-.848-.598 2.8 2.8 0 01-.553-.958 3.964 3.964 0 01-.194-1.283v-.497c0-.477.056-.904.167-1.279.114-.375.281-.692.501-.953a2.1 2.1 0 01.809-.598c.319-.137.685-.206 1.098-.206.49 0 .898.085 1.226.255.331.167.59.398.774.694.187.296.308.633.36 1.01h-.848a1.777 1.777 0 00-.228-.632 1.221 1.221 0 00-.48-.457c-.207-.117-.475-.176-.804-.176a1.7 1.7 0 00-.769.163 1.415 1.415 0 00-.536.465c-.14.203-.246.447-.316.734-.068.287-.101.611-.101.971v.506c0 .369.042.699.127.989.088.29.212.537.374.742a1.614 1.614 0 001.322.62c.302 0 .547-.025.734-.075.188-.053.334-.114.44-.184a1.3 1.3 0 00.241-.207V11.5h-1.48v-.685h2.324zm5.201 2.496V14h-3.388v-.69h3.388zm-3.216-5.708V14h-.849V7.602h.849zm2.768 2.75v.69h-2.94v-.69h2.94zm.404-2.75v.694h-3.344v-.694h3.344zm3.277 0V14h-.835V7.602h.835zm2.056 0v.694h-4.943v-.694h4.944zm3.376 0V14h-.848V7.602h.848zm3.505 0V14h-.835V7.602h.835zm2.056 0v.694h-4.943v-.694h4.944zm7.393 2.997v.404c0 .48-.06.911-.18 1.292-.12.38-.294.704-.52.971a2.25 2.25 0 01-.812.611c-.313.14-.665.21-1.055.21-.378 0-.725-.07-1.041-.21a2.342 2.342 0 01-.818-.61 2.846 2.846 0 01-.531-.972 4.106 4.106 0 01-.19-1.292v-.404c0-.48.062-.91.185-1.288.126-.38.303-.705.532-.971.228-.27.5-.475.813-.615.316-.141.663-.211 1.041-.211.39 0 .742.07 1.055.21.317.141.588.346.813.616.229.266.403.59.523.971.123.378.185.807.185 1.288zm-.84.404v-.413c0-.381-.04-.718-.118-1.01a2.096 2.096 0 00-.339-.74 1.46 1.46 0 00-.549-.452 1.667 1.667 0 00-.73-.154c-.263 0-.502.052-.716.154a1.517 1.517 0 00-.545.453c-.15.199-.265.445-.347.738-.082.293-.123.63-.123 1.01v.414c0 .384.041.724.123 1.02.082.292.2.54.352.742.155.2.338.35.549.453.214.102.453.154.716.154.276 0 .52-.052.734-.154.214-.103.394-.254.54-.453.15-.202.263-.45.34-.742a4.11 4.11 0 00.113-1.02zm6.762-3.401V14h-.853l-3.221-4.935V14h-.848V7.602h.848l3.234 4.948V7.602h.84z",
    fill: "#666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1h118v-2H6v2zm123 5v28h2V6h-2zm-5 33H6v2h118v-2zM1 34V6h-2v28h2zm5 5a5 5 0 01-5-5h-2a7 7 0 007 7v-2zm123-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zm-5-33a5 5 0 015 5h2a7 7 0 00-7-7v2zM6-1a7 7 0 00-7 7h2a5 5 0 015-5v-2z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint0_linear_957_10620",
    x1: 30.087,
    y1: 20.001,
    x2: 21.887,
    y2: 20.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint1_linear_957_10620",
    x1: 23.815,
    y1: 23.971,
    x2: 13.112,
    y2: 32.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint2_linear_957_10620",
    x1: 11.321,
    y1: 9.046,
    x2: 18.457,
    y2: 15.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07F076"
  })))));
}
export default SvgGooglePlay;